import { Box, Chip, Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { format, formatDistance } from "date-fns";
const formatDate = format;
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Healthcheck } from "./WorkerStatus";

export const WorkerStatusPresenter: React.FC<{
  healthchecks: Healthcheck[];
}> = ({ healthchecks }) => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: t('screens.superAdmin.uberAdmin.workerStatus.columns.worker'),
      width: 200,
      editable: false,
      sortable: false,
    },
    {
      field: "status",
      headerName: t('screens.superAdmin.uberAdmin.workerStatus.columns.status'),
      width: 125,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={params.row.status}
            color={params.row.status === "OK" ? "success" : "error"}
          />
        );
      },
    },
    {
      field: "last_updated",
      headerName: t('screens.superAdmin.uberAdmin.workerStatus.columns.lastChecked'),
      width: 250,
      editable: false,
      sortable: false,
      valueGetter: (_, row) => {
        if (!row.last_updated) {
          return t('screens.superAdmin.uberAdmin.workerStatus.notAvailable');
        }
        return formatDate(
          new Date(row.last_updated),
          "yyyy-MM-dd hh:mm:ss a z"
        );
      },
    },
    {
      field: "last_updated_relative",
      headerName: "",
      width: 200,
      editable: false,
      sortable: false,
      valueGetter: (_, row) => {
        if (!row.last_updated) {
          return t('screens.superAdmin.uberAdmin.workerStatus.notAvailable');
        }
        return formatDistance(new Date(row.last_updated), new Date(), {
          addSuffix: true,
        });
      },
    },
  ];
  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ height: "250px", width: "100%" }}
    >
      <Box>
        <Typography variant="subtitle2">{t('screens.superAdmin.uberAdmin.workerStatus.title')}</Typography>
        <Typography variant="body2" color="textSecondary">
          {t('screens.superAdmin.uberAdmin.workerStatus.description')}
        </Typography>
      </Box>
      <DataGrid
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableRowSelectionOnClick
        hideFooterPagination
        hideFooter
        rows={healthchecks}
        columns={columns}
        getRowId={(row) => row.name}
      />
    </Stack>
  );
};
